import api from '@/api';
import mapExampleData from '@/api/mapExampleData';

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        async getMapConfig(context) {
            let guid = mapExampleData.getCurrentOrgGuid(context)
            const url = `/admin/organizations/${guid}/map/config`;
            console.log(`getMapConfig::: orgGuid`, guid)
            return (await api.request("get", url, null, null, false, mapExampleData.getMapExampleAdditionHeaders(context))).data
        },


    },
};
